import { PrismicAuthManager } from "./PrismicAuthManager.js";
const createPrismicAuthManager = (args) => {
  return new PrismicAuthManager(args);
};
export {
  createPrismicAuthManager
};
//# sourceMappingURL=createPrismicAuthManager.js.map
